// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3nqSF","content":"styles_content__384Xd","selectAll":"styles_selectAll__1xyOw"};